import AddCompany from "../../Components/Modals/AddCompany";
import AddUser from "../../Components/Modals/AddUser";
import Table from "../../Components/Table";
import { deleteUserById, getAllUsers } from "../../Services/MasterService";

const User = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Email",
            value: "email"
        },
        {
            label: "Phone",
            value: "phone"
        },
        {
            label: "DOB",
            value: "dob"
        },
        {
            label: "Company",
            value: "company_name"
        },
        {
            label: "Organization",
            value: "organization"
        },
        {
            label: "Designation",
            value: "designation"
        },
        {
            label: "Status",
            value: "status_name",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddUser data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllUsers}
            columns={columns}
            title={"Users Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteUserById}
        />
    );
}

export default User;